import moment from "moment";

const ASCENDING = 'asc';

const STATUS_ORDER = {
    "success": 1,
    "pendiente": 2,
};

const sortByNumber = (a, b, direction) => {
    return direction === ASCENDING ? a - b : b - a;
};

const sortByString = (a, b, direction) => {
    return direction === ASCENDING
        ? a.localeCompare(b)
        : b.localeCompare(a);
};

const sortByStatus = (a, b, direction) => {
    const rankA = STATUS_ORDER[a.toLowerCase()] || 999; // Default to a large number for unknown status
    const rankB = STATUS_ORDER[b.toLowerCase()] || 999;

    return direction === ASCENDING ? rankA - rankB : rankB - rankA;
};

const sortByDate = (a, b, direction) => {
    const FAR_FUTURE = "2500-12-12"; // Fallback for null dates in descending order
    const FAR_PAST = "1900-01-01";   // Fallback for null dates in ascending order

    if (!a && !b) return 0;

    const adjustedA = a || (direction === ASCENDING ? FAR_FUTURE : FAR_PAST);
    const adjustedB = b || (direction === ASCENDING ? FAR_PAST : FAR_FUTURE);

    const dateA = new Date(moment(adjustedA, 'YYYY-MM-DD').toDate());
    const dateB = new Date(moment(adjustedB, 'YYYY-MM-DD').toDate());

    return direction === ASCENDING
        ? dateA - dateB
        : dateB - dateA;
}

export {
    sortByNumber,
    sortByString,
    sortByStatus,
    sortByDate,
};